import type { ReferralStatsSchemaType } from '@/global/schemas/referral.schema';

export enum RedeemOptions {
  CUT_FROM_CURRENT_TIER,
  CUT_FROM_HIGHEST_TIER,
  ONLY_MINT,
}

export interface ClaimRedeemProps {
  availableNode: number;
  nodeId?: string;
  onSuccess?: () => void;
}

export interface RedeemHook {
  referralStats: ReferralStatsSchemaType | undefined;
  isClaiming: boolean;
  isLoadingReferralStats: boolean;
  handleClaimRedeem: (props: ClaimRedeemProps) => Promise<void>;
}
